import React from "react";
import { SearchBar } from "components";
import { InputSimpleDropdown, ToggleSelect } from "@loanbossinc/component-library";
import styled from "styled-components/macro";

import { ClientBrokersGroup, CLIENTS_BROKERS_OPTIONS } from "../constants";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 2em 0;
  min-height: 60%;
  background-color: #FFFFFF;
  max-width: ${(({ maxWidth }) => maxWidth ?? "1920px")};
  flex-wrap: wrap;
  gap: 2em;
`;

const TopSectionWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const BottomSectionWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const InputDropdownWrapper = styled.div`
  font-family: Work Sans;
`;
const StyledToggleSelect = styled(ToggleSelect)`&& {
  button {
    color: #005AA9;
    width: 8vw;
  }

  .Mui-selected {
    background-color: #005AA9;
    color: #FFFFFF;
  }
}`;

const FilterSection = ({
  dropdownName,
  dropdownLabel,
  dropdownOptions,
  selectedDropdownOption,
  onUpdateSelectedDropdownOption: handleUpdateDropdownOption,
  maxWidth,
  searchText,
  onSearchTextUpdate: handleSearchTextUpdate,
  onBrokerClientToggle: handleBrokerClientToggle
}) => (
  <Container maxWidth={maxWidth}>
    <TopSectionWrapper>
      <StyledToggleSelect
        options={CLIENTS_BROKERS_OPTIONS}
        onChange={handleBrokerClientToggle}
        defaultIndex={ClientBrokersGroup.CLIENTS.value}
      />
    </TopSectionWrapper>
    <BottomSectionWrapper>
      <InputDropdownWrapper>
        <InputSimpleDropdown
          name={dropdownName}
          label={dropdownLabel}
          value={selectedDropdownOption}
          options={dropdownOptions}
          onChange={handleUpdateDropdownOption}
        />
      </InputDropdownWrapper>
      <SearchBar
        searchText={searchText}
        setSearchText={handleSearchTextUpdate}
        placeholder="Search contacts by name"
        width="35vw"
      />
    </BottomSectionWrapper>
  </Container>
);

export default FilterSection;
